<template>
	<div id="voucher_word" class="public-content">
		<!-- 公共form表单样式 -->
		<div class="form-item-public">	
			<el-form label-width="90px" inline label-position="left" style='text-align: right;'>
				<el-form-item>
					<el-button size="small" class='minButton' @click="addVoucherModal">添加</el-button>
				</el-form-item>
			</el-form>
		</div>
		<!-- 公共table 样式 -->
		<div class="table-item-public">
			<el-table :data="tableData" border size="small" style="width: 100$;" v-loading="loading">
				<el-table-column prop="certificateWord" label="凭证字" align="center"></el-table-column>
				<el-table-column prop="title" label="凭证标题" align="center"></el-table-column>
				<el-table-column prop="isDefault" label="是否默认" align="center">
					<template slot-scope="scope">
						<span v-if=" scope.row.isDefault == '0' ">是</span>
						<span v-else-if=" scope.row.isDefault == '1' ">否</span>
					</template>
				</el-table-column>
				<el-table-column label="操作" align="center">
					<template slot-scope="scope">
						<el-button type="text" @click="handleEditor(scope.row)">修改</el-button>
						<el-button type="text" @click="handleDelete(scope.row)" style="color: red;">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>

		<!-- 公共 page 样式 -->
		<div class="page-item-public">
			<el-pagination background small
			@size-change="pageSizeChange"  @current-change="pageIndexChange" @prev-click="pageIndexChange" @next-click="pageIndexChange"
			layout="total, prev, pager, next, sizes, jumper" :total="page.totall" :current-page="page.pageIndex" :page-size="page.pageSize">
			</el-pagination>
		</div>
		
		<!-- 弹窗框 -->
		<el-dialog 
			:title="dialog.edit ? '修改凭证字' : '添加凭证字'"
			:visible.sync="dialog.modal" width="420px" :close-on-click-modal="false"
			@close = "cancel('formDataRef')"
			class='default-dialog'
		>
			<div class="form-item-public">
				<el-form  label-width="80px" ref="formDataRef" :model="formData" :rules="dialogRules">
					<el-form-item required label="凭证字:" prop="certificateWord">
						<el-input size="mini"  v-model="formData.certificateWord" placeholder="请输入凭证字" :maxlength="5"></el-input>
					</el-form-item>
					<el-form-item  required label="凭证标题:" prop="title">
						<el-input size="mini" v-model="formData.title" placeholder="请输入凭证标题" :maxlength="5"></el-input>
					</el-form-item>
					<el-form-item label="是否默认:" prop="isDefault">
						<el-select size="mini" v-model="formData.isDefault">
							<el-option label="是" value="0"></el-option>
							<el-option label="否" value="1"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer-right">
				<el-button size="small" @click="cancel('formDataRef')">取消</el-button>
				<el-button size="small" class='minButton' @click="submitVoucher('formDataRef')">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import publicTable from '@/components/publicTable'
export default {
	components:{
		publicTable
	},
	data(){
		return {
			loading:false,
			title:'新增凭证字',
			page:{
				pageIndex:1,
				pageSize:10,
				totall:0,
			},
			dialog:{
				edit:false,
				modal:false,
			},
			formData:{
				certificateWord:'',
				title:'',
				isDefault:''
			},
			dialogRules:{
				certificateWord:[{required:true,message:'请输入凭证字!'}],
				title:[{required:true,message:'请输入凭证标题!'}],
			},
			tableData:[],
		}
	},
	created(){
		this.getTableList();
	},
	methods:{
		getTableList(){
			const _=this;
			//快速访问
			_.loading = true;
			_.$http.post('voucherWord/getVoucherWordList',{
				currentPage:_.page.pageIndex,
				maxResult:_.page.pageSize
			}).then(res=>{
				_.loading = false;
				if(res && res.data.code == '1'){
					_.tableData = res.data.data.list;
					_.page.totall = parseInt(res.data.data.totalCount);
				}
			}).catch(()=>{
				_.loading = false;
			});
		},
		addVoucherModal(){

			const prevent =  this.$getSessionStorage('superPreventOperation');
			if(prevent) {
				this.$store.commit('SUPERPREVENTFUNCTION',true);
				return;
			}
			this.dialog.modal = true;
			this.dialog.edit = false;
			this.formData.id  = '';
		},//提交凭证
		submitVoucher(ref){
			const _=this;
			_.$refs[ref].validate((valid)=>{
				if(valid){
					_.$http.post('voucherWord/save',_.formData).then((res)=>{
						if(res && res.data.code == '1'){
							console.log(res);
							_.$message({
								message:res.data.msg,
								type:'success'
							});
							_.cancel('formDataRef');
							_.getTableList();
						}
					});
					
				}
			});
		},
		handleEditor(row){
			const _=this;

			const prevent =  this.$getSessionStorage('superPreventOperation');
			if(prevent) {
				this.$store.commit('SUPERPREVENTFUNCTION',true);
				return;
			}
			_.dialog.modal = true;
			_.dialog.edit = true;
			_.$nextTick(()=>{
				for(let i in _.formData){
					_.formData[i] = row[i];
				}
				_.formData.id = row.id;
			});
		},
		handleDelete(row){
			const _=this;
			const prevent =  this.$getSessionStorage('superPreventOperation');
			if(prevent) {
				this.$store.commit('SUPERPREVENTFUNCTION',true);
				return;
			}
			_.$confirm('您确定删除标题为“ '+ row.title +' ”的数据吗？','提示',{
				confirmButtonText:'确定',
				cancelButtonText:' 取消',
				type:'warning'
			}).then(()=>{
				_.$http.post('voucherWord/delete',{
					id:row.id
				}).then((res)=>{
					if(res && res.data.code == '1'){
						_.$message({
							message:'删除成功!',
							type:'success'
						})
						this.getTableList();
					}
				});
			}).catch(()=>{
				
			});
		},
		//页码发送变化
		pageIndexChange(page){
			this.page.pageIndex = page;
			this.getTableList();
		},//页码条数发送变化
		pageSizeChange(page){
			this.page.pageSize = page;
			this.getTableList();
		},
		cancel(ref){
			this.$refs[ref].resetFields();
			this.dialog.modal = false;
		}

	},
	mounted() {
		
	},
}
</script>

<style lang="less" scoped>
	#voucher_word{
		background-color: #fff;
		
	}
</style>



// WEBPACK FOOTER //
// src/pages/setting/voucherWord.vue